var storefrontApp = angular.module("storefrontApp");
storefrontApp.service('contestJudgesService', [
    '$http', function (
        $http
    ){
    return {
        getContestJudges: function () {
            return $http.get('storefrontapi/contests/getcontestjudges');
        }
    }
}]);
